
<div class="templates">
	<div class="header">Template Name</div>
	<div class="template" *ngFor="let template of templates"><a [routerLink]="['/admin', 'campaigns', 'templates', template.templateID]">{{template.templateName}}</a><span class="mode-badge" *ngIf="template.editorTypeID === 2">HTML</span></div>
</div>